import { useMemo } from 'react'

import { Chart } from '@/components/common/Chart'
import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { usePage } from '@/components/providers/PageProvider'
import { getTypeDistributionData } from '@/utils/chartUtil'
import { createDynamicComponent } from '@/utils/factoryUtil'

import styles from './ChartsTypeDistribution.module.scss'

const ChartsTypeDistributionGraph = createDynamicComponent({
  loader: () => import('./ChartsTypeDistributionGraph/ChartsTypeDistributionGraph'),
  name: 'ChartsTypeDistributionGraph',
})

export const ChartsTypeDistribution = () => {
  const { page } = usePage()
  const { loading } = useBreakpoints()
  const { typeDistribution } = page?.charts || {}

  const typeDistributionData = useMemo(() => getTypeDistributionData({ typeDistribution }), [typeDistribution])

  if (!typeDistribution) return null

  return (
    <div className={styles.container}>
      <div className={styles.chart}>
        {!loading && <ChartsTypeDistributionGraph typeDistributionData={typeDistributionData} />}
      </div>
      <Chart.Legend>
        {typeDistributionData.slices.map((item, i) => (
          <Chart.LegendItem color={item.fill} key={i} label={item.label} value={String(item.value)} />
        ))}
      </Chart.Legend>
    </div>
  )
}
